import { COMPANY } from "../data/site";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Reveal";

const CONTENT = {
  mentions: {
    eyebrow: "Informations légales",
    title: "Mentions légales",
    index: "05",
    sections: [
      ["Éditeur du site", `Le présent site est édité par ${COMPANY.name}, entreprise artisanale spécialisée dans le chauffage, les énergies renouvelables, la climatisation et la plomberie.\nAdresse : ${COMPANY.address.full}, ${COMPANY.address.department}.\nTéléphone : ${COMPANY.phone} — E-mail : ${COMPANY.email}.\nN° RGE Qualit'EnR : ${COMPANY.rgePlaceholder}. [SIRET à compléter]`],
      ["Hébergement", "Ce site est hébergé par [hébergeur à compléter]."],
      ["Propriété intellectuelle", "L'ensemble des contenus (textes, images, logo) présents sur ce site est la propriété de Lisse Energies, sauf mention contraire. Toute reproduction sans autorisation est interdite."],
      ["Responsabilité", "Lisse Energies s'efforce d'assurer l'exactitude des informations diffusées sur ce site, mais ne saurait être tenue responsable d'éventuelles erreurs ou omissions."],
    ],
  },
  confidentialite: {
    eyebrow: "Vos données",
    title: "Politique de confidentialité",
    index: "06",
    sections: [
      ["Collecte des données", "Les informations recueillies lorsque vous nous contactez (par téléphone ou e-mail) sont utilisées uniquement pour répondre à votre demande."],
      ["Conservation", "Vos données ne sont ni vendues ni cédées à des tiers. Elles sont conservées le temps nécessaire au traitement de votre demande."],
      ["Vos droits", `Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour l'exercer, contactez-nous à ${COMPANY.email}.`],
      ["Cookies", "Ce site n'utilise que les cookies strictement nécessaires à son bon fonctionnement."],
    ],
  },
};

export default function Legal({ type }) {
  const c = CONTENT[type];
  return (
    <div data-testid={`legal-${type}`}>
      <PageHero index={c.index} eyebrow={c.eyebrow} title={c.title} />
      <section className="mx-auto max-w-3xl px-6 pb-28 md:px-12">
        {c.sections.map(([h, body], i) => (
          <Reveal key={h} delay={i * 0.05}>
            <div className="border-t border-[#F0F0F0] py-10">
              <h2 className="text-2xl font-semibold tracking-tight">{h}</h2>
              <p className="mt-4 whitespace-pre-line text-base leading-relaxed text-[#555]">{body}</p>
            </div>
          </Reveal>
        ))}
      </section>
    </div>
  );
}
